<template>
  <div id="nav">
    <!-- NAV BAR -->
    <div :class="{ 'nav-bar-hidden': !showNavBar }" id="nav-bar">

      <div id="bc-logo-mobile">
        <svg
          width="31px"
          height="24px"
          viewBox="0 0 148 115"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <polygon id="path-1" points="0 0 148 0 148 115 0 115"></polygon>
          </defs>
          <g
            id="Design"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="V01-–-Startseite"
              transform="translate(-15.000000, -29.000000)"
            >
              <g id="Group-3" transform="translate(15.000000, 29.000000)">
                <mask id="mask-2" fill="white">
                  <use xlink:href="#path-1"></use>
                </mask>
                <g id="Clip-2"></g>
                <path
                  d="M142.16367,39.4737666 L142.16367,40.9198545 L142.16367,56.8379023 L142.16367,58.4889911 L142.16367,65.4562536 L139.263561,65.4562536 L139.263561,58.4889911 L132.649424,58.4889911 L132.649424,47.9591443 L132.279965,47.5491424 C132.068846,47.3136683 130.14933,45.2581181 127.568678,45.2581181 C124.990803,45.2581181 123.068509,47.3136683 122.860167,47.5491424 L122.490709,47.9591443 L122.490709,58.4889911 L116.068246,58.4889911 L116.068246,65.4562536 L113.168137,65.4562536 L113.168137,58.4889911 L113.168137,56.8379023 L113.168137,39.4737666 L142.16367,39.4737666 Z M142.16367,71.9858113 L142.16367,73.204736 L142.16367,112.077351 L115.095987,112.077351 L113.168137,112.077351 L113.168137,73.204736 L113.148692,73.204736 L113.148692,70.8416843 L113.654266,70.2737763 C114.270956,69.5895163 119.890612,63.572461 127.493675,63.572461 C135.096738,63.572461 140.716393,69.5895163 141.333083,70.2737763 L142.16367,71.2018212 L142.16367,71.9858113 Z M110.270806,68.3899836 L74.0277788,68.3899836 L37.7847517,68.3899836 L37.7847517,39.4737666 L74.0277788,39.4737666 L110.270806,39.4737666 L110.270806,68.3899836 Z M110.270806,103.093322 L74.0277788,103.093322 L37.7847517,103.093322 L37.7847517,71.2793891 L74.0277788,71.2793891 L110.270806,71.2793891 L110.270806,103.093322 Z M79.5196516,112.077351 L69.9415143,112.077351 L69.9415143,105.985498 L74.0277788,105.985498 L79.5196516,105.985498 L79.5196516,112.077351 Z M34.8846428,56.7824966 L34.8846428,58.4889911 L34.8846428,65.4008479 L31.9873118,65.4008479 L31.9873118,58.4889911 L25.4676227,58.4889911 L25.4676227,47.9591443 L25.0981643,47.5491424 C24.8898232,47.3136683 22.9675288,45.2581181 20.3896543,45.2581181 C17.8090018,45.2581181 15.8894853,47.3136683 15.6783663,47.5491424 L15.308908,47.9591443 L15.308908,58.4889911 L8.7447727,58.4889911 L8.7447727,65.4008479 L5.84466384,65.4008479 L5.84466384,58.4889911 L5.84466384,56.7824966 L5.84466384,40.9198545 L5.84466384,39.4737666 L34.8846428,39.4737666 L34.8846428,56.7824966 Z M34.8846428,71.9858113 L34.8846428,73.2518308 L34.8846428,112.077351 L5.84466384,112.077351 L5.84466384,73.2518308 L5.84466384,71.9858113 L5.84466384,70.8860089 L6.35023837,70.3208711 C6.96692819,69.6338408 12.5865836,63.6195558 20.1924246,63.6195558 C27.7927099,63.6195558 33.4151432,69.6338408 34.0290551,70.3208711 L34.8846428,71.2738485 L34.8846428,71.9858113 Z M16.9867488,11.5659327 L23.7897819,11.5659327 L34.7540824,36.5815909 L5.96966853,36.5815909 L16.9867488,11.5659327 Z M50.8324637,22.6609173 L51.201922,22.2481451 C51.3797064,22.051455 52.9936559,20.3227982 55.182627,20.3227982 C57.3688202,20.3227982 58.9855475,22.051455 59.1605541,22.2481451 L59.5327903,22.6609173 L59.5327903,32.8333976 L50.8324637,32.8333976 L50.8324637,22.6609173 Z M81.2752731,22.6609173 L81.6475093,22.2481451 C81.8225159,22.051455 83.4392432,20.3227982 85.6254364,20.3227982 C87.8144074,20.3227982 89.4283569,22.051455 89.6061414,22.2481451 L89.9755997,22.6609173 L89.9755997,32.8333976 L81.2752731,32.8333976 L81.2752731,22.6609173 Z M95.7758174,22.6609173 L96.1452757,22.2481451 C96.3202823,22.051455 97.9370096,20.3227982 100.123203,20.3227982 C102.306618,20.3227982 103.926123,22.051455 104.103908,22.2481451 L104.473366,22.6609173 L104.473366,32.8333976 L95.7758174,32.8333976 L95.7758174,22.6609173 Z M124.265776,11.5659327 L131.068809,11.5659327 L142.030331,36.5815909 L113.301475,36.5815909 L124.265776,11.5659327 Z M145.063779,39.4737666 L145.063779,39.4737666 L148,39.4737666 L148,36.5815909 L145.063779,36.5815909 L145.063779,36.27963 L132.963324,8.67375699 L129.118736,8.67375699 L129.118736,2.89217576 L126.218627,2.89217576 L126.218627,8.50199942 L109.162431,0 L75.4778333,0 L72.5777244,0 L38.8931266,0 L21.8397087,8.50199942 L21.8397087,2.89217576 L18.9395998,2.89217576 L18.9395998,8.67375699 L15.0922332,8.67375699 L2.93899921,36.27963 L2.93899921,36.5815909 L0,36.5815909 L0,39.4737666 L2.99177897,39.4737666 L2.94455498,39.4737666 L2.94455498,68.3899836 L0,68.3899836 L0,71.2793891 L2.94455498,71.2793891 L2.94455498,112.077351 L0,112.107824 L0,115 L108.976313,114.969527 L115.095987,114.969527 L148,114.969527 L148,112.077351 L145.063779,112.077351 L145.063779,71.2793891 L148,71.2793891 L148,68.3899836 L145.063779,68.3899836 L145.063779,40.9198545 L145.063779,39.4737666 Z M127.568678,77.0637406 C124.990803,77.0637406 123.068509,79.1192908 122.860167,79.3547649 L122.490709,79.7675371 L122.490709,94.9874735 L132.649424,94.9874735 L132.649424,79.7675371 L132.279965,79.3547649 C132.068846,79.1192908 130.14933,77.0637406 127.568678,77.0637406 L127.568678,77.0637406 Z M20.3896543,77.0637406 C17.8090018,77.0637406 15.8894853,79.1192908 15.6783663,79.3547649 L15.308908,79.7675371 L15.308908,94.9874735 L25.4676227,94.9874735 L25.4676227,79.7675371 L25.0981643,79.3547649 C24.8898232,79.1192908 22.9675288,77.0637406 20.3896543,77.0637406 L20.3896543,77.0637406 Z M104.473366,79.4018597 L104.103908,78.9890875 C103.926123,78.7923974 102.306618,77.0637406 100.123203,77.0637406 C97.9370096,77.0637406 96.3202823,78.7923974 96.1452757,78.9918578 L95.7758174,79.4018597 L95.7758174,94.9874735 L104.473366,94.9874735 L104.473366,79.4018597 Z M89.9755997,79.4018597 L89.6061414,78.9890875 C89.4283569,78.7923974 87.8144074,77.0637406 85.6254364,77.0637406 C83.4392432,77.0637406 81.8225159,78.7923974 81.6475093,78.9918578 L81.2752731,79.4018597 L81.2752731,94.9874735 L89.9755997,94.9874735 L89.9755997,79.4018597 Z M24.3675814,22.2481451 C24.1897969,22.051455 22.5730696,20.3227982 20.3896543,20.3227982 C18.2034611,20.3227982 16.5867337,22.051455 16.4061714,22.2481451 L16.0422689,22.6609173 L16.0422689,32.8333976 L24.7398176,32.8333976 L24.7398176,22.6609173 L24.3675814,22.2481451 Z M131.646608,22.2481451 C131.468824,22.051455 129.852097,20.3227982 127.665903,20.3227982 C125.47971,20.3227982 123.865761,22.051455 123.687976,22.2481451 L123.318518,22.6609173 L123.318518,32.8333976 L132.018845,32.8333976 L132.018845,22.6609173 L131.646608,22.2481451 Z M62.4301213,45.2581181 C60.246706,45.2581181 58.6272007,46.9867749 58.4494163,47.183465 L58.079958,47.5962372 L58.079958,61.3174504 L66.7775067,61.3174504 L66.7775067,47.5962372 L66.4080484,47.183465 C66.2330418,46.9867749 64.6163144,45.2581181 62.4301213,45.2581181 L62.4301213,45.2581181 Z M47.9323548,45.2581181 C45.7461616,45.2581181 44.1322122,46.9867749 43.9544277,47.183465 L43.5849694,47.5962372 L43.5849694,61.3174504 L52.285296,61.3174504 L52.285296,47.5962372 L51.9130598,47.183465 C51.7352753,46.9867749 50.118548,45.2581181 47.9323548,45.2581181 L47.9323548,45.2581181 Z M104.473366,47.5962372 L104.103908,47.183465 C103.926123,46.9867749 102.306618,45.2581181 100.123203,45.2581181 C97.9370096,45.2581181 96.3202823,46.9867749 96.1452757,47.183465 L95.7758174,47.5962372 L95.7758174,61.3174504 L104.473366,61.3174504 L104.473366,47.5962372 Z M89.9755997,47.5962372 L89.6061414,47.183465 C89.4283569,46.9867749 87.8144074,45.2581181 85.6254364,45.2581181 C83.4392432,45.2581181 81.8225159,46.9867749 81.6475093,47.183465 L81.2752731,47.5962372 L81.2752731,61.3174504 L89.9755997,61.3174504 L89.9755997,47.5962372 Z M62.4301213,77.0637406 C60.246706,77.0637406 58.6272007,78.7923974 58.4494163,78.9918578 L58.079958,79.4018597 L58.079958,94.9874735 L66.7775067,94.9874735 L66.7775067,79.4018597 L66.4080484,78.9890875 C66.2330418,78.7923974 64.6163144,77.0637406 62.4301213,77.0637406 L62.4301213,77.0637406 Z M47.9323548,77.0637406 C45.7461616,77.0637406 44.1322122,78.7923974 43.9544277,78.9918578 L43.5849694,79.4018597 L43.5849694,94.9874735 L52.285296,94.9874735 L52.285296,79.4018597 L51.9130598,78.9890875 C51.7352753,78.7923974 50.118548,77.0637406 47.9323548,77.0637406 L47.9323548,77.0637406 Z"
                  id="Fill-1"
                  fill="#223976"
                  mask="url(#mask-2)"
                ></path>
              </g>
            </g>
          </g>
        </svg>
      </div>

      <!-- DISPLAY WHERE YOU ARE -->
      <div id="section-title">
        <h1 v-if="showNav == true">Basel Academy</h1>
        <h1 v-else-if="$route.hash == '#einleitung-section'">Einleitung</h1>
        <h1 v-else-if="$route.hash == '#team-section'">Team</h1>
        <h1 v-else-if="$route.hash == '#projekte-section'">Projekte</h1>
        <h1 v-else-if="$route.hash == '#publikationen-section'">Publikationen</h1>
        <h1 v-else-if="$route.hash == '#mitglieder-section'">Verein</h1>
        <h1 v-else-if="$route.hash == '#kontakt-section'">Kontakt</h1>
        <h1 v-else>Basel Academy</h1>
        
      </div>

      <div v-show="!showNav" id="nav-burger">
        <svg @click="showNav = !showNav" width="32px" height="21px" viewBox="0 0 32 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
            <g transform="translate(-273.000000, -20.000000)" stroke="#20377A">
              <g transform="translate(274.000000, 20.000000)">
                <line x1="0.365853659" y1="0.5" x2="29.6341463" y2="0.5" id="Line-2"></line>
                <line x1="0.365853659" y1="10.5" x2="29.6341463" y2="10.5" id="Line-2-Copy"></line>
                <line x1="0.365853659" y1="20.5" x2="29.6341463" y2="20.5" id="Line-2-Copy-2"></line>
              </g>
            </g>
          </g>
        </svg>
      </div>

      <div v-show="showNav" id="nav-close">
        <svg @click="showNav = !showNav" width="30px" height="21px" viewBox="0 0 30 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
              <line x1="0.365853659" y1="0.5" x2="29.5" y2="20.5" stroke="#20377A"></line>
              <line x1="0.365853659" y1="20.5" x2="29.5" y2="0.5" stroke="#20377A"></line>
            </g>
        </svg>
      </div>
      
    </div>

    <!-- OVERLAY CONTENT -->
    <transition name="fadeNav">
      <div v-if="showNav" id="overlay-wrapper">
        <div id="overlay-content">
          <a @click="showNav = false" href="#einleitung-section" class="type-xl">
            <span v-if="$i18n.locale == 'default'">Einleitung</span>
            <span v-else>Introduction</span>
          </a>
          <a @click="showNav = false" href="#team-section" class="type-xl">Team</a>
          <a @click="showNav = false" href="#projekte-section" class="type-xl">
            <span v-if="$i18n.locale == 'default'">Projekte</span>
            <span v-else>Projects</span>
          </a>
          <a @click="showNav = false" href="#publikationen-section" class="type-xl">
            <span v-if="$i18n.locale == 'default'">Publikationen</span>
            <span v-else>Publications</span>
          </a>
          <a @click="showNav = false" href="#mitglieder-section" class="type-xl">
            <span v-if="$i18n.locale == 'default'">Verein</span>
            <span v-else>Members</span>
          </a>
          <a @click="showNav = false" href="#kontakt-section" class="type-xl">
            <span v-if="$i18n.locale == 'default'">Kontakt</span>
            <span v-else>Contact</span>
          </a>
          <div class="type-xs" id="lang-switch">
            <span @click="switchLang('default')">DE</span> / 
            <span @click="switchLang('english')">EN</span>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "NavigationMobile",
  props: {
    switchLang: {
      type: Function,
      required: true,
    }
  },
  data() {
    return {
      showNav: false,
      showNavBar: false,
      lastScrollPosition: 0
    };
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll () {
      // Get the current scroll position
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop

      if (currentScrollPosition > 100) {
        this.showNavBar = true;
      } else {
        this.showNavBar = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>

#nav-bar {
  padding: 1rem 1.5rem 0.5rem 1.5rem;
  width: 100%;
  display: flex;
  // justify-content: space-between;
  align-items: flex-start;
  position: fixed;
  top: 0;
  left: 0;
  background-color: white;
  z-index: 100;
  transform: translate3d(0, 0, 0);
  transition: 0.3s;

  &.nav-bar-hidden {
    transform: translate3d(0, -100%, 0);
    transition: 0.3s;
  }
  
  & #bc-logo-mobile {
    padding-right: 1.2rem;
    padding-top: 0.1rem;
  }
  
  & #nav-burger, #nav-close{
  margin-left: auto;
  padding-top: 0.4rem;

}
}

svg {
  cursor: pointer;
}

#overlay-wrapper {
  height: 100vh;
  width: 100%;
  position: fixed;
  overflow: hidden;
  top: 0;
  z-index: 99;
  background-color: white;
  transition: 0.3s;
}
#overlay-content {
  position: relative;
  padding: 1.5rem;
  padding-top:  5.7rem; // adjust based on nav-bar height
  padding-left: 5.8rem; // adjust to align with section title
  & a {
    display: block;
    padding-bottom: 1.5rem;
  }
}

.fadeNav-enter-active, .fadeNav-leave-active {
  transition: all 0.5s;
  max-height: 100vh; // must be heigher than the content
}
.fadeNav-enter, .fadeNav-leave-to /* .fade-leave-active below version 2.1.8 */ {
  max-height: 0px;
}

</style>